import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ProductInformationSheet from '../../../../Manufacturer/print/ProductInformationSheet';
import { LoadingButton } from '@mui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCarTFormDetails } from '../../../../../slices/carTForm';
import {  selectFollowCycle } from '../../../../../slices/common';
// import { cartInitialValues } from '../../../../../components/features/ManufacturingForm/Common';
import NoDataCard from '../../../../../../components/no-data-card';

const DownloadCARTForm = ({patientData, patientInfo}) => {
    let sendData={...patientData, ...patientInfo}
        const [cartFormPrint, setCartFormPrint] = useState(false)
           const [checkCarTForm, setCheckCarTForm] = useState({})
           const dispatch=useDispatch()
   const currentCycle = useSelector(selectFollowCycle);
//    console.log('currentCycle', currentCycle)
        //    const [initialValues, setInitialValues] = useState(cartInitialValues)
// console.log("patientData.patient_information", patientData)
    // Memoize fetchCarTForm with useCallback
    const fetchCarTForm = async (coaFormId) => {
        try {
            const response = await dispatch(
                fetchCarTFormDetails({ product_manufacturing_id: currentCycle.product_manufacturing_id, id: coaFormId })
            ).unwrap();
            if (response?.status == 200) {
                const dataValues = response?.data
                // if (dataValues?.status != 'draft' && currentCycle?.car_t_manufacturing_form_id) {
                //     setDisabledAll(true)
                // }else{
                //     setDisabledAll(false)
                // }
                // handleTerminateCase()
                // setQueryFields(dataValues.queries);
                // const parsedCellCount = Array.isArray(dataValues.cell_count) && dataValues.cell_count?.length ? dataValues?.cell_count : Array.isArray(dataValues.cell_count) && dataValues.cell_count?.length < 1 ? cartInitialValues?.cell_count_1 :  JSON.parse(dataValues.cell_count);
                // const [firstCellCount, ...restCellCount] = parsedCellCount;
                // setInitialValues({
                // ...dataValues,
                // ...dataValues?.status == 'draft' ? {additional_day: cartInitialValues?.additional_day}:{},
                //  cell_count_1: firstCellCount ? [firstCellCount] : [],
                //  cell_count: restCellCount?.length > 0 ? restCellCount : []
                // });
                setCheckCarTForm(dataValues)
                
            }
        } catch (error) {
            console.error("Error fetching car t form details:", error);
        }
    }

    useEffect(() => {
        if(currentCycle?.car_t_manufacturing_form_id)
        fetchCarTForm(currentCycle?.car_t_manufacturing_form_id)
        // handleServerDropdown()
    }, [currentCycle?.car_t_manufacturing_form_id, currentCycle?.product_manufacturing_id])

  return (<Box>

   <Box  sx={{
       display: 'flex',
       justifyContent: 'flex-end',
    }}>
          {currentCycle?.car_t_manufacturing_form_id && <LoadingButton
              type="button"
              size="small"
              onClick={() => setCartFormPrint(true)}
              className="!w-[100px]"
              >
              Print
          </LoadingButton>}
              </Box>
         {(Object.keys(checkCarTForm)?.length > 0 && currentCycle?.car_t_manufacturing_form_id) ? <ProductInformationSheet open={cartFormPrint}
              onClose={() => {
                  setCartFormPrint(false);
              }}
              data={checkCarTForm}
              patientInfo={sendData}
              isVisible={true} />:
               <div>
                        <NoDataCard heading="No Data to Display" />
                    </div>}
      </Box>
  )
}

export default DownloadCARTForm